import type { PlayerStore } from '@cartwhl/3d/player/store/playerStore';

import { sanitizePromptAsFilename } from '@cartwhl/common/utils/sanitizePromptAsFilename';

import { noticesStore } from 'stores/global';

import {
  motionEditorVideoExportState,
  startMotionEditorVideoRecording,
} from './motionEditorVideoExportStore';

function triggerMp4Download(href: string, sceneName?: string) {
  if (!href) {
    return;
  }

  let filename = 'Cartwheel-export.mp4';
  if (sceneName) {
    const sanitized = sanitizePromptAsFilename(sceneName, 50);
    filename = `Cartwheel-${sanitized}.mp4`;
  }

  const aTag = document.createElement('a');
  aTag.href = href;
  aTag.download = filename;
  document.body.appendChild(aTag);
  aTag.click();
  aTag.remove();
  noticesStore.success('Download has begun!');
}

/** Encode (if needed) and trigger browser download for scene MP4 — shared by modal footer and panel preview. */
export async function runSceneVideoDownload(
  playerStore: PlayerStore,
  sceneName: string,
): Promise<void> {
  const recordedVideo = motionEditorVideoExportState.recordedVideo;
  if (recordedVideo && recordedVideo.size > 0) {
    const url = URL.createObjectURL(recordedVideo);
    triggerMp4Download(url, sceneName);
    URL.revokeObjectURL(url);
    return;
  }
  if (motionEditorVideoExportState.isRecording) {
    return;
  }

  const blob = await startMotionEditorVideoRecording(playerStore);
  if (blob) {
    const url = URL.createObjectURL(blob);
    triggerMp4Download(url, sceneName);
    URL.revokeObjectURL(url);
  }
}
